import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Overview from './pages/Overview';
import UserList from './pages/UserList';
import UserDetail from './pages/UserDetail';
import DashboardList from './pages/DashboardList';
import DashboardDetail from './pages/DashboardDetail';
import TokensPage from './pages/TokensPage';
import IssueReportsPage from './pages/IssueReportsPage';
import './styles.css';

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div className="shell">
      <Sidebar />
      <main className="main">{children}</main>
    </div>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />
      <Route path="/" element={<RequireAuth><Shell><Overview /></Shell></RequireAuth>} />
      <Route path="/users" element={<RequireAuth><Shell><UserList /></Shell></RequireAuth>} />
      <Route path="/users/:id" element={<RequireAuth><Shell><UserDetail /></Shell></RequireAuth>} />
      <Route path="/dashboards" element={<RequireAuth><Shell><DashboardList /></Shell></RequireAuth>} />
      <Route path="/dashboards/:id" element={<RequireAuth><Shell><DashboardDetail /></Shell></RequireAuth>} />
      <Route path="/tokens" element={<RequireAuth><Shell><TokensPage /></Shell></RequireAuth>} />
      <Route path="/issue-reports" element={<RequireAuth><Shell><IssueReportsPage /></Shell></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
